
export const convertCurrencyToInt = (amt) => {
    return amt ? parseInt(amt.replace(/\$/g, ''), 10) : 0;
};

// export const formatCurrency = (value) => {
//     if (value === 0) {
//         return "$0";
//     } else if (value <= 0) {
//         const absValue = Math.abs(value);
//         const formatted = absValue.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
//         console.log('-$${formatted}', `-$${formatted}`, value);
//         return `-$${formatted}`;
//     } else {
//         const absValue = Math.abs(value);
//         const formatted = absValue.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
//         console.log('$${formatted}', `$${formatted}`, value);
//         return `$${formatted}`;
//     }
// }

export const formatCurrency = (value, isFloatRequiredForZero = true) => {
    if (value === 0) { // if value is 0, return $0.00 or $0 depending on the isFloatRequiredForZero
        return isFloatRequiredForZero ? '$0.00' : '$0';
    }
    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    });
    return formatter.format(value);
};
